module.exports = __webpack_public_path__ + "img/brand-5.15c1a788.png";